// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import * as VueGoogleMaps from 'vue2-google-maps'
import 'bootstrap-css-only/css/bootstrap.min.css'
import 'mdbvue/build/css/mdb.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
import './assets/css/custom.css'
import SortedTablePlugin from "vue-sorted-table"
import VueShowdown from 'vue-showdown'

import Axios from 'axios'
Vue.prototype.$http = Axios;
const token = localStorage.getItem('token')
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = 'Bearer ' + token
}
Vue.use(VueGoogleMaps, {
  load: {
    libraries: 'places'
  }
})

Vue.use(VueShowdown)

Vue.use(SortedTablePlugin);

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router,
  store,
  components: { App }
  }).$mount('#app')
  
  
